import React from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, useLocation } from 'react-router-dom';
import { useProfile } from '../hooks';
import { isBillingOnlyPath, needsSubscriptionSelection } from '../lib/utils/subscriptionAccess';

const SubscriptionRoute = ({ children }) => {
  const { t } = useTranslation();
  const { profile, loading } = useProfile();
  const location = useLocation();

  // Only block the tree on the initial profile load — never unmount pages
  // during background/auth refresh when we already have a profile.
  if (loading && !profile) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">{t('common.loading')}</p>
        </div>
      </div>
    );
  }

  if (needsSubscriptionSelection(profile) && !isBillingOnlyPath(location.pathname)) {
    return <Navigate to="/billing" replace />;
  }

  return children;
};

export default SubscriptionRoute;
